import { render, staticRenderFns } from "./AssetsCategory.vue?vue&type=template&id=2dfa4d86&scoped=true&"
import script from "./AssetsCategory.vue?vue&type=script&lang=js&"
export * from "./AssetsCategory.vue?vue&type=script&lang=js&"
import style0 from "./AssetsCategory.vue?vue&type=style&index=0&id=2dfa4d86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa4d86",
  null
  
)

export default component.exports